import PropTypes from 'prop-types';

import proNotifications from 'modules/proNotifications';

import AvatarIcon from 'components/AvatarIcon';
import StateLink from 'components/StateLink';
import Currency from 'modules/Currency';

import './Notification.scss';

/**
 * Add a credit card to an appointment notification
 */
export default function ApptAddCreditCard(props) {
  const { notification } = props;

  return (
    <StateLink
      to="provider.appointment"
      params={{ viewApptId: notification.appointment_id }}
      clickTracking={{
        name: proNotifications.NOTIFICATION_CLICKED_EVENT,
        params: proNotifications.createNotificationParams(notification),
      }}
    >
      <section className="notification">
        <div className="icon">
          <AvatarIcon
            icon={notification.client_thumbnail}
            name={notification.client_name}
          />
        </div>
        <section className="notification-body add-cc-text">
          <p className="notification-text">
            <strong>Add a card on file for {notification.client_name}&apos;s future appointments</strong> at checkout.
          </p>
          <p className="from-now">
            <span className="amt-due">{Currency.format(notification.total_appt_cost)} Due</span> &bull; {proNotifications.getFromNowDisplay(notification.creation_time)}
          </p>
        </section>
      </section>
    </StateLink>
  );
}

ApptAddCreditCard.propTypes = {
  /** The notification object */
  notification: PropTypes.object.isRequired,
};
